// eslint-disable-next-line
import {
  getUser,
  getMe,
  updateMe,
  uploadUserPhotoV2,
  getCourse,
  updateCourse,
  getNotifications,
  updateNotifications,
} from '@/api/index';

import {
  omit,
} from 'lodash';

export default {
  namespaced: true,
  state: {
    /* = data */
    currentTab: 'GolfCourse',

    user: {},
    notifications:[],
    golfCourse: {},
    loadingUserData: false,
    loading: {
      golfCourse: true,
      updateData: false,
      userData: false,
    },
  },

  getters: {
    /* = Computed properties, perfects to filter data an execute some calculation */

    // Notifications
    getEmailNotifications(state) {
      if (state.notifications.length > 0) {
        let tempArray = state.notifications.filter(item => item.notification.type == 'EMAIL');
        return tempArray.sort((a, b) => {return a.notification.orden - b.notification.orden});
      }
      return [];
    },
    getPushNotifications(state) {
      if (state.notifications.length > 0) {
        let tempArray = state.notifications.filter(item => item.notification.type == 'PUSH');
        return tempArray.sort((a, b) => {return a.notification.orden - b.notification.orden});
      }
      return [];
    },
  },

  mutations: {
    /* Mutations are responsible to change the state */
    setCurrentTab(state, tab) {
      state.currentTab = tab;
    },
    setUserPhoto(state, photo) {
      state.user.photo_url = photo;
    },
    setUser(state, user) {
      state.user = user;
    },
    
    // Golf Course
    setCourse(state, course) {
      state.golfCourse = course;
    },
    setLoading(state, loading) {
      state.loading = {
        ...state.loading,
        ...loading,
      };
    },
    addBackgroundPhoto(state, photo) {
      state.golfCourse.background_images.unshift(photo);
    },
    // Notifications
    setNotifications(state, notifications) {
      state.notifications = notifications;
    }

  },

  actions: {
    /* = Methods */
    // User
    apiGetUser(context, userId) {
      getUser(userId).then((res) => {
        context.commit('setUser', omit(res, ['deleted', 'time_created', 'time_updated', 'logo_url',
          'golf_courses', 'user_type', 'photo_url', 'type_id'
        ]));
      });
    },
    apiGetMe(context) {
      getMe().then((res) => {
        context.commit('setUser', omit(res, ['deleted', 'time_created', 'time_updated', 'logo_url',
          'golf_courses', 'user_type', 'type_id'
        ]));
      });
    },

    async apiUpdateMe({ commit, state }, userNewPhoto) {
      commit('setLoading', {
        userData: true,
      });
      await updateMe(state.user, true).then(async (user) => {

        if (userNewPhoto && userNewPhoto.url) {
          await uploadUserPhotoV2(user.user_id, userNewPhoto).then(userWithPhoto => {
            if (userWithPhoto) {
              // Refactor service to upload user photos and also refactor uploadPhoto to return just data
              user = userWithPhoto;
            }
          });
        }
        
        commit('setUser', user);
      }).finally(() => {
          commit('setLoading', { userData: false });
        });
    },

    // Golf Course
    async apiGetCourse(context) {
      context.commit('setLoading', {
        golfCourse: true,
      });
      await getCourse().then((res) => {
        if (res.background_images.length > 0) {
          res.background_images.map(image => image.deleted = false);
        }
        context.commit('setCourse', omit(res, ['deleted', 'time_created', 'time_updated']));
      });
      context.commit('setLoading', {
        golfCourse: false,
      });
    },
    async apiUpdateCourse(context) {
      context.commit('setLoading', {
        updateData: true,
      });
      let tempCourse = omit(context.state.golfCourse, ['background_images']);
      await updateCourse(context.state.golfCourse.course_id, {
        ...tempCourse,
      }).then((res) => {
        if (res.background_images.length > 0) {
          res.background_images.map(image => image.deleted = false);
        }
        context.commit('setCourse', omit(res, ['deleted', 'time_created', 'time_updated']));
      });
      context.commit('setLoading', {
        updateData: false,
      });
    },

    // Notifications
    apiGetNotifications(context, userId) {
      getNotifications(userId).then(notifications => {
        context.commit('setNotifications', notifications);
      })
    },
    apiChangeStatus(context, notification) {
      let tempNotify = {
        notification_id: notification.notification_id,
        active: notification.active,
      };
      updateNotifications([tempNotify])
    }
  },
};
